import { TruncateWithTooltip } from '~/modules/settings/components/TruncateWithTooltip';

export function LabelName({ name }: { name: string }) {
  return (
    <TruncateWithTooltip className="inline-block">{name}</TruncateWithTooltip>
  );
}

LabelName.displayName = 'LabelName';
